export default __webpack_public_path__ + "5d711ac5b6348ddbaa3eeaf9bd947e41.svg";